import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const getVisitorId = () => {
  try {
    let id = localStorage.getItem("lf_visitor");
    if (!id) {
      id = window.crypto && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("lf_visitor", id);
    }
    return id;
  } catch {
    return "anon";
  }
};

export const VisitTracker = () => {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith("/admin") || path === "/login") return;
    api.post("/track", { path, visitor_id: getVisitorId() }).catch(() => {});
  }, [location.pathname]);
  return null;
};
